/** @format */

import React from 'react';
import { FACTS_FIELD_KEYS } from '../utilities';
import './styles.scss';
import { Unit, checkIfValueIsValid } from '../common';

const fieldsToIgnore = [
  'maxNumberOffBedroom',
  'maxNumberOfBedroom',
  'rooms',
  'numberOffBedroom',
  'numberOfBedroom',
  'numberOfRooms',
  'numberOfBedrooms',
  'maxNumberOfBedrooms'
];

export const getInteriorData = (props) => {
  const { dataSet, objectText } = props;

  const factKey = FACTS_FIELD_KEYS.INTERIOR;

  const interiorData = dataSet[factKey] || {};
  const roomsData = interiorData?.rooms || [];

  interiorData.areaSource = dataSet?.baseInfo?.areaSource;
  interiorData.areaSourceComment = dataSet?.baseInfo?.areaSourceComment;
  interiorData.livingArea = dataSet?.baseInfo?.livingSpace;
  interiorData.otherSpace = dataSet?.baseInfo?.otherSpace;
  interiorData.buildingSpace = dataSet?.baseInfo?.buildingSpace;

  const InteriorFactsRow = ({ facts }) => {
    const areaFields = ['livingArea', 'otherSpace', 'buildingSpace'];

    const factFieldName = facts?.factFieldName;
    if (checkIfValueIsValid(facts?.value)) {
      return (
        <div className='object-listing-accordian-list object-listing-accordian-list-no-border'>
          <div className='object-listing-accordian-list-left'>
            {objectText?.[`${factKey}Obj`]?.[factFieldName]?.label ||
              objectText?.[factKey]?.[factFieldName]?.label ||
              facts?.factFieldName}
          </div>
          <div className='object-listing-accordian-list-right'>
            {facts?.value} <Unit areaFields={areaFields} facts={facts} />
          </div>
        </div>
      );
    }

    return <></>;
  };

  let otherFields = [];

  const bedRooms = {
    min:
      interiorData?.numberOffBedroom ||
      interiorData?.numberOfBedroom ||
      interiorData?.numberOfBedrooms,
    max:
      interiorData?.maxNumberOffBedroom ||
      interiorData?.maxNumberOfBedroom ||
      interiorData?.maxNumberOfBedrooms
  };

  Object.keys(interiorData).forEach((fieldKey, index) => {
    if (!fieldsToIgnore.includes(fieldKey)) {
      otherFields.push(
        <InteriorFactsRow
          key={index}
          facts={{
            factFieldName: fieldKey,
            value: interiorData[fieldKey]
          }}
        />
      );
    }
  });

  const RoomDataSection = () => {
    if (Array.isArray(roomsData) && roomsData?.length) {
      return (
        <>
          <div className='section-separator'></div>
          <div className='object-listing-accordian-list object-listing-accordian-list-no-border'>
            <div className='object-listing-accordian-list-left'>
              {objectText?.interiorObj?.rooms?.label}
            </div>
            <div className='object-listing-accordian-list-right'></div>
          </div>
          <div className='object-listing-accordian-list object-listing-accordian-list-no-border'>
            <div className='list-of-rooms-wrapper'>
              {roomsData.map((room) => {
                return (
                  <div className='list-of-rooms' key={room.heading + room.text}>
                    <strong>{room.heading}</strong> - {room.text}
                  </div>
                );
              })}
            </div>
          </div>
        </>
      );
    }

    return <></>;
  };

  const InteriorSection = () => {
    return (
      <div className='interior-data-body'>
        <InteriorFactsRow
          key='numberOfRooms'
          facts={{
            factFieldName: 'numberOfRooms',
            value: interiorData['numberOfRooms']
          }}
        />
        <InteriorFactsRow
          key='numberOfBedRooms'
          facts={{
            factFieldName: 'numberOfBedRooms',
            value: (() => {
              let text = `${bedRooms.min}`;

              if (bedRooms.max) {
                text = text + ` - ${bedRooms.max}`;
              }

              return text;
            })()
          }}
        />
        {otherFields}
        <RoomDataSection />
      </div>
    );
  };

  console.log('---- called ineterior data');

  return {
    component: <InteriorSection />,
    factsCount: 2 + otherFields.length + roomsData.length
  };
};
